export class GroupMessage {
    timeStamp = new Date().getTime();//唯一的时间戳
    time = GroupMessage.formatDate(this.timeStamp);
    mes = '';
    sendJid = '';
    receiveJid = '';
    isSent = '';
    messageName = '';
    avatarUrl = '';

    public static of(o: unknown): GroupMessage {
        return Object.assign(new GroupMessage(), o);
    }
    static formatDate(timeStamp: number){
        //三目运算符
        const Dates = new Date(timeStamp);

        //年份
        const Year: number = Dates.getFullYear();

        //月份下标是0-11
        const Months: any = ( Dates.getMonth() + 1 ) < 10  ?  '0' + (Dates.getMonth() + 1) : ( Dates.getMonth() + 1);

        //具体的天数
        const Day: any = Dates.getDate() < 10 ? '0' + Dates.getDate() : Dates.getDate();

        //小时
        const Hours = Dates.getHours() < 10 ? '0' + Dates.getHours() : Dates.getHours();

        //分钟
        const Minutes = Dates.getMinutes() < 10 ? '0' + Dates.getMinutes() : Dates.getMinutes();

        //秒
        const Seconds = Dates.getSeconds() < 10 ? '0' + Dates.getSeconds() : Dates.getSeconds();



        //返回数据格式
        // return Year + '-' + Months + '-' + Day + '-' + Hours + ':' + Minutes + ':' + Seconds;
        return Months + '-' + Day + '-' + Hours + ':' + Minutes;
    }
}
